module.exports = __webpack_public_path__ + "media/images/type-7-5414fdbe1db38543afb2b31029474fb2.png";